module.exports = __webpack_public_path__ + "img/pd-img39.ecea8648.jpg";